import countryAPI from '../../api/Country'
import * as types from '../mutation-types'

// STATE
const state = {
    Country: {},
    CountryOptions: [],
    AvailableCountryOptions: []
}

// GETTERS
const getters = {
    CountryOptions: state => state.CountryOptions,
    AvailableCountryOptions: state => state.AvailableCountryOptions,
    Country: state => state.Country
}

// ACTIONS
const actions = {
    getCountryOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            countryAPI.getCountryOptions(countryOptions => {
                commit(types.RECEIVE_COUNTRY_OPTIONS, { countryOptions })
                resolve()
            }, params)
        })
    },
    getAvailableCountryOptions({ commit }, params) {
        return new Promise((resolve, reject) => {
            countryAPI.getAvailableCountryOptions(availableCountryOptions => {
                commit(types.RECEIVE_AVAILABLE_COUNTRY_OPTIONS, { availableCountryOptions })
                resolve()
            }, params)
        })
    },
    getCountry({ commit }, id) {
        return new Promise((resolve, reject) => {
            countryAPI.getCountry(country => {
                commit(types.RECEIVE_COUNTRY, { country })
                resolve()
            }, id)
        })
    },
    updateCountry({ commit }, params) {
        return new Promise((resolve, reject) => {
            countryAPI.updateCountry(country => {
                resolve(country)
            }, params)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_COUNTRY_OPTIONS] (state, { countryOptions }) {
        state.CountryOptions = countryOptions
    },
    [types.RECEIVE_AVAILABLE_COUNTRY_OPTIONS] (state, { availableCountryOptions }) {
        state.AvailableCountryOptions = availableCountryOptions
    },
    [types.RECEIVE_COUNTRY] (state, { country }) {        
        state.Country = country
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/Country.js